export const landingContent = {
  seo: {
    title: 'Combine Pickaxes — Merge & Upgrade Mining Game',
    description:
      'A fun 2D merge game: combine pickaxes, upgrade tools, smash rocks and trees, and earn more coins with every upgrade.',
    ogImage: ''
  },

  game: {
    name: 'Combine Pickaxes',
    tagline: 'Merge pickaxes. Break more. Earn faster.',
    description:
      'A fun 2D merge game where simple tools turn into powerful pickaxes. Combine identical pickaxes, upgrade your gear, and smash rocks, trees, and more. The stronger your tool, the more money you earn—build the ultimate set of pickaxes.',
    heroImageSrc: '/media/hero/hero-1.png',

    // CTA под web-игру
    primaryCta: 'Play on Y8',
    secondaryCta: 'Watch Gameplay',

    highlights: [
      'Merge identical pickaxes to unlock stronger tools',
      'Smash obstacles faster to earn more coins',
      'Build the ultimate tool set and keep upgrading'
    ],

    platformLine: 'Web Browser ',
    storeLinks: [
      {
        name: 'Y8',
        url: 'https://y8.com/games/combine_pickaxes',
        iconSrc: '/media/platforms/y8.png',
        icon: 'Y8',
        color: '#f97316'
      },
      {
        name: 'Yandex Games',
        url: 'https://yandex.com/games/app/473675',
        iconSrc: '/media/platforms/yandex.png',
        icon: 'Я',
        color: '#ef4444'
      },
      {
        name: 'Playhop',
        url: 'https://playhop.com/app/473675',
        iconSrc: '/media/platforms/playhop.png',
        icon: 'P',
        color: '#22c55e'
      }
    ]
  },

  navigation: [
    { id: 'hero', label: 'Home' },
    { id: 'trailer', label: 'Gameplay' },
    { id: 'screenshots', label: 'Screenshots' },
    { id: 'reviews', label: 'Reviews' },
  ],

  features: [
    {
      title: 'Merge to Upgrade',
      description:
        'Combine two identical pickaxes to create a stronger tool and unlock new tiers.'
    },
    {
      title: 'Satisfying Smash Loop',
      description:
        'Break rocks, trees, and more—stronger tools clear faster and feel better.'
    },
    {
      title: 'Earn More Coins',
      description:
        'The better your pickaxe, the more money you generate. Upgrade to accelerate income.'
    },
    {
      title: 'Build the Ultimate Set',
      description:
        'Collect, merge, and optimize your pickaxes to create the perfect toolkit.'
    },
    {
      title: 'Simple & Addictive',
      description:
        'Easy to start, hard to stop—quick sessions with constant progression.'
    },
    {
      title: 'Always Progressing',
      description:
        'Keep improving your tools and pushing through tougher obstacles as you grow stronger.'
    }
  ],



    trailer: {
    title: 'Gameplay Preview',
    description:
      'A quick look at merging pickaxes, upgrading tools, and smashing obstacles.',
    trailerUrl: '/media/trailer/trailer.gif'
  },
  screenshots: Array.from({ length: 4 }, (_, index) => ({
    id: `s-${index + 1}`,
    title: `Screenshot ${index + 1}`,
    imageSrc: `/media/screenshots/shot-${index + 1}.png`
  })),
  // Отзывы — более развернутые и с реалистичными именами
reviews: [
  {
    source: 'Player Review',
    quote:
      'I started playing just to try it out for a few minutes, and suddenly an hour had passed. The merge system is simple, but watching your pickaxes become stronger and smash through obstacles faster is really satisfying.',
    author: 'Alex Turner'
  },
  {
    source: 'Community Comment',
    quote:
      'Great little game for short sessions. The upgrade loop is very clear: merge, smash, earn, repeat. It feels rewarding every time you unlock a stronger pickaxe.',
    author: 'Maria Kovalenko'
  },
  {
    source: 'Arcade Player',
    quote:
      'At first it looks simple, but once you start optimizing your pickaxes and income, it becomes surprisingly addictive. Perfect if you like idle or merge-style games.',
    author: 'Daniel Brooks'
  },
  {
    source: 'Casual Gamer',
    quote:
      'I like how easy it is to understand. You don’t need a tutorial—just merge tools and see the progress immediately. It’s relaxing and satisfying at the same time.',
    author: 'Sophie Laurent'
  },
  {
    source: 'Browser Game Fan',
    quote:
      'The progression feels smooth, and each upgrade makes a noticeable difference. It’s one of those games where you always want to unlock just one more pickaxe.',
    author: 'Ivan Petrov'
  },
  {
    source: 'First Impressions',
    quote:
      'Simple mechanics, clean visuals, and a very satisfying gameplay loop. It’s easy to jump in for five minutes, but hard to stop once you start merging higher-tier tools.',
    author: 'Lucas Mendes'
  }
],

  // Платформы под web-игру: основная — браузер/Y8
  platforms: [
    { name: 'Play on Y8 (Browser)', storeUrl: 'https://ru.y8.com/games/combine_pickaxes' },
    { name: 'Web (Embed / Portal)', storeUrl: '' }
  ],

  faq: [
    {
      question: 'What is the goal of the game?',
      answer:
        'Merge identical pickaxes to upgrade your tools and earn more coins by smashing obstacles.'
    },
    {
      question: 'How do upgrades work?',
      answer:
        'Combine two identical pickaxes to create a stronger one. Stronger tools earn faster.'
    },
    {
      question: 'Is it free to play?',
      answer: 'Yes, you can play it online in your browser.'
    },
    {
      question: 'Do I need to download anything?',
      answer: 'No—just open the game in a web browser.'
    },
    {
      question: 'Can I play on mobile?',
      answer:
        'If your landing supports it, you can add mobile links later. For now: browser on PC.'
    }
  ],

  finalCta: {
    title: 'Ready to combine your first pickaxe?',
    buttonText: 'Play Now'
  },

  footer: {
    contactEmail: 'contact@placeholder.game',
    socials: [
      { name: 'Discord', url: '' },
      { name: 'X / Twitter', url: '' },
      { name: 'YouTube', url: '' },
      { name: 'TikTok', url: '' }
    ],
    copyright: '2026 Combine Pickaxes. All rights reserved.'
  }
};
